import { API_BASE_URL } from "../API/Api";

const STORAGE_BASE_URL = "https://api.uktomars.co.uk/storage";

export const resolveImageUrl = (path) => {
  if (!path) return "";
  const str = String(path);
  if (str.startsWith("http") || str.startsWith("blob:")) return str;

  const cleanPath = str.replace(/^\//, "");
  if (cleanPath.startsWith("files/")) {
    return `${STORAGE_BASE_URL}/${cleanPath}`;
  }

  return `${API_BASE_URL}/${cleanPath}`;
};

export const normalizeImagePath = (value) => {
  if (!value) return "";
  const str = String(value).trim();
  if (!str) return "";

  const basePrefix = `${API_BASE_URL}/`;
  if (str.startsWith(basePrefix)) {
    return str.slice(basePrefix.length).replace(/^\//, "");
  }

  if (str.startsWith("http")) {
    try {
      const { pathname } = new URL(str);
      const storageIndex = pathname.indexOf("/storage/");
      if (storageIndex !== -1) {
        return pathname
          .slice(storageIndex + "/storage/".length)
          .replace(/^\//, "");
      }
    } catch {
      return str;
    }
  }

  return str.replace(/^\//, "");
};

export const normalizeEventImage = (item) => {
  if (!item) return null;

  if (typeof item === "object" && !Array.isArray(item)) {
    const path = normalizeImagePath(item.path || "");
    const url = item.url || (path ? resolveImageUrl(path) : "");
    if (!path && !url) return null;

    return {
      id: item.id ?? null,
      path: path || normalizeImagePath(url),
      url,
      sort_order: item.sort_order ?? 0,
      alt_text: item.alt_text ?? null,
    };
  }

  const path = normalizeImagePath(item);
  if (!path) return null;

  return {
    id: null,
    path,
    url: resolveImageUrl(path),
    sort_order: 0,
    alt_text: null,
  };
};

export const parseEventImages = (images) => {
  if (!images) return [];

  if (Array.isArray(images)) {
    return images
      .map(normalizeEventImage)
      .filter(Boolean)
      .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
  }

  if (typeof images === "string") {
    const trimmed = images.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parseEventImages(parsed);
      }
    } catch {
      // fall through
    }

    return trimmed
      .split(",")
      .map((item) => normalizeEventImage(item.trim()))
      .filter(Boolean);
  }

  return [];
};

export const getEventImageUrl = (image) => {
  if (!image) return "";
  if (typeof image === "string") return resolveImageUrl(image);
  return image.url || resolveImageUrl(image.path);
};

export const getEventImagePaths = (images) =>
  parseEventImages(images).map((image) => image.path).filter(Boolean);

export const extractUploadedImagePath = (uploadData) => {
  const raw =
    uploadData?.image_path ||
    uploadData?.path ||
    uploadData?.data?.image_path ||
    uploadData?.data?.path ||
    uploadData?.url ||
    uploadData?.data?.url ||
    "";

  return normalizeImagePath(raw);
};

export const extractUploadedImageUrl = (uploadData, path) =>
  uploadData?.url ||
  uploadData?.data?.url ||
  (path ? resolveImageUrl(path) : "");
